import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { OrderedList } from '../components/blocks/OrderedList';

export const isOrderedList = isElementType(OrderedList);
